export default function formatUsd(int) {
  return '$' + int.toLocaleString() + ' USD';
}
